module.exports = __webpack_public_path__ + "images/supportIcon-a269d08bbb02dd8e26a7b96610267324.svg";